var $eab312ee632ab3b3$exports = {};
// Google
/*
  The measurement ID, with a default rather than an env var alone.

  `process.env.GTAG_ID` was the only source, and it is set nowhere -- not in
  frontend/Dockerfile, not in any workflow, not in a .env. Parcel inlines
  `process.env.*` at build time, so `process.env.GTAG_ID && gtag('config', ...)`
  folded to `undefined && ...` and the config call was dropped from the bundle
  outright. Checked against a built dist: it contains no gtag("config") call at
  all. Analytics has therefore never been initialised on the SPA -- `gtag` existed,
  every event went into dataLayer, and nothing was ever sent anywhere.

  A GA4 measurement ID is not a secret; it ships in the page source of every site
  that uses one. Hardcoding the default is what makes this work without new build
  plumbing, and the env var still overrides it for a separate property.
*/ const $eab312ee632ab3b3$var$GTAG_ID = "G-DBV9KL7MSE";
/*
  Which hosts are allowed to report, and why this is a *runtime* check.

  A build-time gate cannot work here. The release pipeline promotes the very same
  image from staging to production -- that is the point of promotion, so that the
  artifact reaching production is the one dev.br1game.com ran -- so `NODE_ENV` and
  every other build-time value are identical in both places. Only the hostname the
  bundle is served from can tell them apart.

  This matters because the default above applies everywhere. Without the check,
  turning analytics on would also point dev.br1game.com, every local `yarn start`
  and every preview build at the live property, quietly filling production
  reporting with staging traffic. Nothing was being sent before, so that would be
  a new problem introduced by fixing this one.

  An explicit GTAG_ID is taken as deliberate and skips the check, which is how a
  non-production environment opts in to a property of its own.
*/ const $eab312ee632ab3b3$var$REPORTING_HOSTS = [
    "br1game.com",
    "www.br1game.com"
];
const $eab312ee632ab3b3$var$analyticsEnabled = Boolean(undefined) || $eab312ee632ab3b3$var$REPORTING_HOSTS.includes(window.location.hostname);
if ($eab312ee632ab3b3$var$analyticsEnabled) {
    const gtagScript = document.createElement("script");
    gtagScript.type = "text/javascript";
    gtagScript.setAttribute("async", "true");
    // The `id` query parameter is required: it is how gtag/js knows which stream's
    // configuration to fetch. Without it the script loads and initialises nothing,
    // which is the second half of why this was silently dead.
    gtagScript.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${$eab312ee632ab3b3$var$GTAG_ID}`);
    document.head.appendChild(gtagScript);
}
/*
  `window.gtag` is defined even when reporting is off, and `dataLayer` still
  collects. `utils/analytics.ts` already treats a missing `gtag` as "do nothing",
  but leaving it undefined off production would mean the tracking calls are only
  ever exercised on production -- a call site with a bad argument would be found
  by users rather than in development. This way the calls run everywhere and only
  the transmission is gated.
*/ window.dataLayer = window.dataLayer || [];
function $eab312ee632ab3b3$var$gtag() {
    dataLayer.push(arguments);
}
window.gtag = $eab312ee632ab3b3$var$gtag;
if ($eab312ee632ab3b3$var$analyticsEnabled) {
    $eab312ee632ab3b3$var$gtag("js", new Date());
    $eab312ee632ab3b3$var$gtag("config", $eab312ee632ab3b3$var$GTAG_ID, {
        debug_mode: false
    });
    undefined;
}


//# sourceMappingURL=index.42295457.js.map
